import { getTaskListDataByProjectId } from '../tasks/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId, ISelectItem, IEntitySelectItem } from '~/types/models'
import type { IProject, IProjectOverview } from '@/types/project/models'

const projectListData = undefined as unknown as IProject[]

export const getProjectListData = getListDataFunctionFactory<IProject[]>({
  listData: projectListData,
  storageKey: 'projects',
  getStartingListData: getStartingProjectListData,
})

export function _getProjDataById(id: TEntityId, list: IProject[]): IProject {
  if (!list) {
    throw new Error(`_getProjDataById called with undefined/null list`)
  }
  const project = list.find((p: IProject) => p.id === id)
  if (!project) {
    throw new Error(`Can't find project '${id}'`)
  }
  return project
}

export function _getProjSelectItemDataById(
  id: TEntityId,
  list: IProject[]
): IEntitySelectItem | undefined {
  const project = list.find((p: IProject) => p.id === id)
  if (project) {
    return {
      id: project.id,
      label: project.descr,
    }
  } else return undefined
}

export async function getProjectDataById(
  id: TEntityId
): Promise<IProject | undefined> {
  const list = await getProjectListData()
  return _getProjDataById(id, list)
}

export async function getProjectSelectItemDataById(
  id: string
): Promise<IEntitySelectItem | undefined> {
  const list = await getProjectListData()
  return _getProjSelectItemDataById(id, list)
}

export async function getProjectOverviewDataById(
  id: string
): Promise<IProjectOverview> {
  const theProjectData = await getProjectDataById(id)
  if (!theProjectData) {
    throw new Error(`Project data for ${id} not found`)
  }
  const theOverviewData = {
    project: theProjectData,
    tasks: await getTaskListDataByProjectId(id),
    opportunities: [],
    orderServiceOrders: [],
    serviceRequests: [],
    cases: [],
  }
  return theOverviewData
}

export async function getStartingProjectListData(): Promise<IProject[]> {
  return [
    {
      id: 'XXP0001',
      hrid: 'P0001',
      descr: 'Call Center Refresh',
      startDate: '2021-04-01',
      plannedDoneDate: '2021-12-20',
      doneDate: '2021-12-01',
      owner: {
        id: 'XXTM0001',
        label: 'Meryl Streep',
      },
      assignedTo: {
        id: 'XXTM0004',
        label: 'Scarlett Johansson',
      },
      priority: {
        id: 1,
        label: 'High',
      },
      status: {
        id: 4,
        label: 'Complete',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXP0002',
      hrid: 'P0002',
      descr: 'E-LAN to DIA Migration',
      startDate: '2021-10-01',
      plannedDoneDate: '2022-04-12',
      doneDate: 'Pending',
      owner: {
        id: 'XXTM0001',
        label: 'Meryl Streep',
      },
      assignedTo: {
        id: 'XXTM0003',
        label: 'Benedict Cumberbatch',
      },
      priority: {
        id: 1,
        label: 'High',
      },
      status: {
        id: 2,
        label: 'In Progress',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXP0003',
      hrid: 'P0003',
      descr: 'POTS Lines',
      startDate: '2000-01-01',
      plannedDoneDate: '2002-04-12',
      doneDate: 'Pending',
      owner: {
        id: 'XXTM0001',
        label: 'Meryl Streep',
      },
      assignedTo: {
        id: 'XXTM0003',
        label: 'Benedict Cumberbatch',
      },
      priority: {
        id: 1,
        label: 'High',
      },
      status: {
        id: 5,
        label: 'Retired',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
